import axios from 'axios'
import setupFormatResponse from './apiFormatResponse'

const apis = {
  reservation: axios.create({
    baseURL: process.env.REACT_APP_RESERVATION_URL,
    responseType: 'json',
  }),

  audit: axios.create({
    baseURL: process.env.REACT_APP_AUDIT_URL,
    responseType: 'json',
  }),

  default: axios.create({
    baseURL: process.env.REACT_APP_ROOT_API_URL,
    responseType: 'json',
  }),
}

for (const i in apis) {
  // skip reservation
  if (['reservation'].indexOf(i) === -1) {
    apis[i].interceptors.response.use(
      function(response) {
        return response.data
      },
      function(error) {
        console.error(error)
        return Promise.reject(error)
      }
    )
  }
}

// format response of api
setupFormatResponse([apis.reservation])

const getApi = key => {
  if (!apis.hasOwnProperty(key)) {
    console.error(`Api key '${key}' does not exist!`)
  }
  return apis[key]
}

const setAccessToken = token => {
  for (const i in apis) {
    apis[i].defaults.headers.common['Access-Token'] = token
    apis[i].defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
}

export {getApi, setAccessToken}

export default apis.default
